// extracted by mini-css-extract-plugin
module.exports = {"StartCard":"styles_StartCard__2ICt3","StartLogo":"styles_StartLogo__1zM3i","StartFormField":"styles_StartFormField__Iut9p","StartDescription":"styles_StartDescription__2yFj_"};